import React, { Component } from 'react';
import { WithStyles } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { Typography, Grid, Button } from '@material-ui/core';
import { styles } from '../styling/WithNoContent'

interface NoContentProps extends WithStyles<typeof styles> {
	createContentOpenHandler: Function
}

interface NoContentStates {
}

class NoContent extends Component<NoContentProps, NoContentStates> {
	constructor(props: NoContentProps) {
		super(props);
	}

	render() {

		const { classes, createContentOpenHandler } = this.props;

		return (
			<>
				<Grid container
					spacing={0}
					direction="column"
					alignItems="center"
					justify="center"
					style={{ minHeight: '100vh' }}>
					<Grid item className={classes.center}>
						<img alt="no content" className={classes.img} src="/assets/img/course/no-content.png" />
						<Typography variant="h6" gutterBottom>Its so lonely here...</Typography>
						<Typography variant="caption" gutterBottom>No Courses have been shared with you yet. Get started by authoring your own course.</Typography>
						<Button
							className={classes.button}
							variant="contained"
							color="primary"
							onClick={(e) => createContentOpenHandler(e)}
						>
							Create Course
						</Button>
					</Grid>
				</Grid>
			</>
		)
	}
}

// @ts-ignore
export default withStyles(styles)(NoContent);
